import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  portfolioSummary: null,
  portfolioSummaryDetail: null,
  portfolioPosition: null,
};

const subAccountSlice = createSlice({
  name: "subAccounts",
  initialState,
  reducers: {
    setSubAccountSummary: (state, action) => {
      state.portfolioSummary = action.payload;
    },
    setSubAccountPortfolioDetail: (state, action) => {
      state.portfolioSummaryDetail = action.payload;
    },
    setSubAccountPortfolioPosition: (state, action) => {
      state.portfolioPosition = action.payload;
    },
  },
});

export const {
  setSubAccountSummary,
  setSubAccountPortfolioDetail,
  setSubAccountPortfolioPosition,
} = subAccountSlice.actions;
export default subAccountSlice.reducer;
